import {
  ADMIN_REQUEST,
  ADMIN_ERROR,
  ADMIN_SUCCESS,
  ADMIN_REGISTER,
  ADMIN_REGISTER_SUCCESS,
  ADMIN_REGISTER_ERROR,
  ADMIN_VALIDATE,
  ADMIN_VALIDATE_SUCCESS,
  ADMIN_VALIDATE_ERROR,
} from '@/store/actions/admin';
import { AUTH_LOGOUT, AUTH_REQUEST } from '@/store/actions/auth';
import { handleRequestError } from '@/utils/error';
import Repository, { ADMINS } from '@/repositories/RepositoryFactory';

const AdminRepository = Repository.get(ADMINS);

const state = {
  status: '',
  error: '',
  profile: {},
  isAdminRegistrationSuccessful: null,
  validateStatus: '',
};

const getters = {
  isAdminRegistrationSuccessful: state => state.isAdminRegistrationSuccessful,
  adminStatus: state => state.status,
  isProfileLoaded: state => !!state.profile.email || !!state.profile.phone,
  me: state => state.profile,
  adminValidateStatus: state => state.validateStatus,
};

const actions = {
  [ADMIN_REQUEST]: async ({ commit }) => {
    commit(ADMIN_REQUEST);
    try {
      commit(ADMIN_SUCCESS, await AdminRepository.getSelf());
    } catch (error) {
      commit(ADMIN_ERROR);
      handleRequestError(error);
    }
  },

  [ADMIN_REGISTER]: async ({ commit, dispatch }, data) => {
    commit(ADMIN_REGISTER);
    try {
      const response = await AdminRepository.register(data);
      await dispatch(AUTH_REQUEST, {
        email: data.email,
        password: data.password,
      });
      commit(ADMIN_REGISTER_SUCCESS, response);
    } catch (error) {
      commit(ADMIN_REGISTER_ERROR);
      handleRequestError(error);
    }
  },

  [ADMIN_VALIDATE]: async ({ commit }, payload) => {
    commit(ADMIN_VALIDATE);
    try {
      await AdminRepository.validateIsUnique(payload);
      commit(ADMIN_VALIDATE_SUCCESS);
    } catch (error) {
      commit(ADMIN_VALIDATE_ERROR);
      handleRequestError(error);
    }
  },
};

const mutations = {
  [ADMIN_REQUEST]: state => {
    state.status = 'loading';
  },
  [ADMIN_SUCCESS]: (state, response) => {
    const { data: user } = response.data;
    state.status = 'success';
    state.profile = user;
  },
  [ADMIN_ERROR]: state => {
    state.status = 'error';
  },
  [ADMIN_REGISTER]: state => {
    state.status = 'loading';
    state.isAdminRegistrationSuccessful = null;
  },
  [ADMIN_REGISTER_SUCCESS]: (state, response) => {
    const { data: user } = response;
    state.status = 'success';
    state.profile = user;
    state.isAdminRegistrationSuccessful = true;
  },
  [ADMIN_REGISTER_ERROR]: state => {
    state.status = 'error';
    state.isAdminRegistrationSuccessful = false;
  },
  [AUTH_LOGOUT]: state => {
    state.profile = {};
    state.featureList = {};
  },
  [ADMIN_VALIDATE]: state => {
    state.validateStatus = 'loading';
  },
  [ADMIN_VALIDATE_SUCCESS]: state => {
    state.validateStatus = 'success';
  },
  [ADMIN_VALIDATE_ERROR]: state => {
    state.validateStatus = 'error';
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
